const $fundraisingOrganizationUnorderedList = $('[data-js-fundraising-organization-list]');
const $fundraisingOrganizationDropdown = $('[data-js-fundraising-organization-select]');
const $fundraisingOrganizationWidget = $('[data-js-fundraising-sidebar-widget]');

/**
 * Sort alphabetically
 * @param a
 * @param b
 * @return {number}
 */
const sortAlphabetical = (a, b) => {
  const aText = a.innerText.trim().toLowerCase();
  const bText = b.innerText.trim().toLowerCase();
  return aText.localeCompare(bText);
};

/**
 * Partition children into premier, featured, and general tiers.
 * @param {JQuery} $container
 * @return {{
 *   premierOrganizations: JQuery,
 *   featuredOrganizations: JQuery,
 *   generalOrganizations: JQuery,
 * }}
 */
const getTierGroups = ($container) => ({
  premierOrganizations: $container.children("[data-premier='true']"),
  featuredOrganizations: $container.children("[data-premier='false'][data-featured='true']"),
  generalOrganizations: $container.children("[data-premier='false'][data-featured='false']"),
});

/**
 * Sort each tier and append in premier → featured → general order.
 * @param {JQuery} $container
 * @param {function} sortFn
 */
const sortAndAppendTierGroups = ($container, sortFn) => {
  const {
    premierOrganizations,
    featuredOrganizations,
    generalOrganizations,
  } = getTierGroups($container);

  premierOrganizations.sort(sortFn);
  featuredOrganizations.sort(sortFn);
  generalOrganizations.sort(sortFn);

  $container
    .append(premierOrganizations)
    .append(featuredOrganizations)
    .append(generalOrganizations);
};

$(() => {
  // if the organization display type is alphabetical, rearrange the charity order
  if (window.RR.organizationDisplayTypeIsAlphabetical) {
    const sortFn = sortAlphabetical;

    // Show fundraising organizations individual widget
    if (window.RR.showFundraisingOrganizationWidgetSidebarWidget) {
      sortAndAppendTierGroups($fundraisingOrganizationWidget.first(), sortFn);
    }

    // Show fundraising organization list/dropdown widget
    if (!window.RR.showFundraisingOrganizationWidgetSidebarWidget) {
      const $fundraisingOrganizationList = window.RR.showFundraisingOrganizationWidgetAsDropdown
        ? $fundraisingOrganizationDropdown.first()
        : $fundraisingOrganizationUnorderedList.first();

      sortAndAppendTierGroups($fundraisingOrganizationList, sortFn);
    }
  }
});
